import { FC } from 'react';
import { cn } from '@fe-learner-common';
import { formatDate } from '@fe-learner-common/utils/date';

type CalendarIconProps = {
  className?: string;
  date: number;
  size: 'md';
  disabled?: boolean;
};

const sizeMap = {
  md: 'lf:w-[40px] lf:h-[40px] lf:min-w-[40px] lf:min-h-[40px]',
};

export const CalendarIcon: FC<CalendarIconProps> = ({
  className,
  date,
  size,
  disabled,
  ...rest
}) => {
  return (
    <div
      className={cn(
        'lf:flex lf:flex-col lf:rounded-lg lf:bg-neutral-0 lf:text-center lf:shadow-50',
        className,
        sizeMap[size],
      )}
      {...rest}
    >
      <p
        className={cn(
          'lf:text lf:rounded-t-lg lf:bg-negative-500 lf:text-[.5rem] lf:font-bold lf:uppercase lf:leading-[0.875rem] lf:tracking-[0.5px] lf:text-neutral-0',
          {
            'lf:bg-neutral-500': disabled,
          },
        )}
      >
        {formatDate(date, 'MMM')?.replace('.', '')}
      </p>
      <p className="lf:flex lf:flex-1 lf:items-center lf:justify-center lf:text-label-lg">
        {formatDate(date, 'd')}
      </p>
    </div>
  );
};
